import { Database } from 'lucide-react';

import { NodeShell } from './NodeShell';

interface UpdateCallNodeData {
  label: string;
  mappings?: Array<{ field: string; value: string }>;
}

export const UpdateCallNode = ({
  data,
  selected,
}: {
  data: UpdateCallNodeData;
  selected?: boolean;
}) => {
  const count = data.mappings?.length ?? 0;
  return (
    <NodeShell
      type="update_call"
      icon={<Database size={16} />}
      label={data.label}
      subtitle={count > 0 ? `${count} field${count !== 1 ? 's' : ''}` : undefined}
      selected={selected}
    />
  );
};
